import React from "react";
import HeroImage from "../assets/HeroImg.png";
import { NavLinks } from "../reusable/NavLinks";
import Team  from "./Team.jsx"

import WhoWeAre from "./WhoWeAre";
import Footer from "../reusable/Footer";
import WhatWeBelieve  from "./WhatWeBelieve.js";
import Location from "./Location.js";
import ChurchLocation from "./Location.js";



export const About = () => {
  return (
    <div className="about">
      <NavLinks />
      <section className="hero is-fullheight-with-navbar">
        <div className="circle orange"></div>
        <div className="circle red"></div>
        <div className="circle blue"></div>
        {/* comment */}
        <div className="hero-body">
          <div className="container">
            <div className="columns is-vcentered is-multiline">
              <div className="column is-6">
                <h1 className="title custom-text-color is-1 has-text-weight-bold">
                  Welcome to <br />
                  Apostolic <span className="has-text-black">Community!</span>
                </h1>
                <p className="subtitle custom-text-color is-5 mt-3">
                  Here's everything you need to know before you arrive this
                  Sunday.
                </p>
                <button className="button custom-text-color custom-button mt-4">
                  Let us know you're coming!
                </button>
              </div>

              <div className="column is-6">
                <figure className="image">
                  <img
                    className="rounded-oval"
                    src={HeroImage}
                    alt="Community Worship"
                  />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section">

        {/* <div className="wave-divider">
  <svg viewBox="0 0 1440 150" preserveAspectRatio="none">
    <path
      d="M0,0 C480,100 960,0 1440,100 L1440,150 L0,150 Z"
      fill="#f9f9f9"
    />
  </svg>
</div> */}


        <div className="container">
          <div className="rounded-menu custom-text-color">
            <a href="#">Who We Are</a>
            <a href="#">What We Believe</a>
            <a href="#">Meet The Team</a>
            <a href="#">Plan a Visit</a>
          </div>
        </div>
      </section>
      {/* Jeevan's code push */}
      <section className="who-we-are">
        <WhoWeAre/>
        <WhatWeBelieve/>

        

        <Team/>
        
      <ChurchLocation/>
        

      </section>
      <Footer/>
    </div>
  );
};
